module.exports = "/assets/data/5e87e642044ea0f871c5adfcb01d0744-SN15.data.json";